/**
 * A date as the person's own calendar has it, YYYY-MM-DD (phase-16 A-5).
 * Not `toISOString().slice(0, 10)`: that is the UTC date, which for anyone
 * east of Greenwich is yesterday until the small hours.
 */
export function localIsoDate(at: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`;
}
